<template>
  <div class="print-model">
    <div id="printMe" ref="printMe" v-if="!loading">
      <PurchasePayment :item="item" />
    </div>
  </div>
</template>
<script>
import PurchasePayment from './components/purchasePayment.vue'
export default {
  data() {
    return {
      path: '/purchasepayments',
      logo: localStorage.getItem('logo'),
      item: {},
      loading: true
    }
  },
  methods: {
    getitem() {
      this.item = this.$parent.printedPurchasePayment
      this.loading = false
      var myel = this
      setTimeout(function () {
        var text = document.getElementById('printMe').innerHTML
        document.getElementById('printMe').remove()
        var myframe = document.getElementById('inviceIframe')
        myframe.contentDocument.body.classList.add('payment-style')
        myframe.contentDocument.body.innerHTML = text
        setTimeout(function () {
          myframe.focus()
          myframe.contentWindow.print()
          myel.colse()
        }, 100)
      }, 20)
    },
    colse() {
      this.$parent.printedPurchasePayment = false
    }
  },
  mounted() {
    this.getitem()
  },
  components: {
    PurchasePayment
  },
  props: ['options']
}
</script>
